/* eslint-disable react/require-default-props */

import React from 'react';
import { Box, Icon, Typography } from '@saviynt/design-system';
import cx from 'classnames';

import './Breadcrumbs.css';

interface BreadcrumbItem {
  label: string;
  href?: string; // Optional href for navigation
  isActive?: boolean;
}

interface BreadcrumbsProps {
  items?: BreadcrumbItem[];
  className?: string;
}

/**
 * Breadcrumbs navigation component showing the current page location
 *
 * @param props - The component props
 * @returns JSX element containing the breadcrumb navigation
 */
function Breadcrumbs({
  items = [
    { label: 'Role Recommendations', href: '../' },
    { label: 'Role Details', isActive: true },
  ],
  className,
}: BreadcrumbsProps) {
  return (
    <Box className={cx('Roles-Breadcrumbs', className)}>
      <nav className='Roles-Breadcrumbs-nav' aria-label='Breadcrumb navigation'>
        <ol className='Roles-Breadcrumbs-list'>
          {items.map((item, index) => (
            <li key={item.label} className='Roles-Breadcrumbs-item'>
              {/* Breadcrumb text */}
              {item.href && !item.isActive ? (
                // TODO: change these to Link component
                <a href={item.href} className='Roles-Breadcrumbs-link'>
                  <Typography
                    kind='body1'
                    color='--color-foreground-primary-medium'>
                    {item.label}
                  </Typography>
                </a>
              ) : (
                <Typography
                  kind='body1'
                  color={
                    // TODO: update when figma is updated
                    item.isActive
                      ? '--color-foreground-neutral-subtle'
                      : '--color-foreground-neutral-subtle'
                  }>
                  {item.label}
                </Typography>
              )}

              {/* Separator icon */}
              {index < items.length - 1 && (
                <Icon
                  kind='ChevronRight'
                  size='small'
                  color='--color-foreground-neutral-subtle'
                  className='Roles-Breadcrumbs-separator'
                />
              )}
            </li>
          ))}
        </ol>
      </nav>
    </Box>
  );
}

export default Breadcrumbs;
